/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { Button } from 'reactstrap';
import CursorLeft from '../../../../icons/CursorLeft';
import CursorRight from '../../../../icons/CursorRight';
import { Game } from '../../../../services/betting';
import { GameMini } from '../../../GameMini';

interface LeafGridHeadingProps {
    games: Game[];
    startColumn: number;
    columnCount: number;
    leftEnabled: boolean;
    rightEnabled: boolean;
    onColumnLeft: () => void;
    onColumnRight: () => void;
}

export const LeafGridHeading: React.FC<LeafGridHeadingProps> = (props) => {
    const renderGame = (g: Game) => {
        return (
            <th
                key={g.id}
                className="align-middle text-center ps-md-1 pe-md-1 ps-lg-2 pe-lg-2 border-left border-bottom-0 border-top-0 pe-sm-0 ps-sm-0"
                style={{ lineHeight: '21px' }}
            >
                <GameMini gameId={String(g.id)} team1={g.team1} team2={g.team2} />
            </th>
        );
    };

    if (props.games) {
        return (
            <tr className="">
                <th className="d-none d-md-table-cell border-bottom-0 border-top-0" />
                <th className="align-middle text-end ps-md-1 pe-md-1 ps-lg-2 pe-lg-4 border-right border-bottom-0 border-top-0 pe-sm-0 ps-sm-0">
                    {props.leftEnabled && (
                        <Button className="btn-r1gray" onClick={props.onColumnLeft} disabled={!props.leftEnabled}>
                            <CursorLeft />
                        </Button>
                    )}
                </th>
                {props.games.map((g, index) => {
                    if (index >= props.startColumn && index < props.startColumn + props.columnCount) {
                        return renderGame(g);
                    }
                    return null;
                })}
                <th className="align-middle border-left border-bottom-0 border-top-0 ps-md-1 pe-md-1 ps-lg-2 pe-lg-2">
                    {props.rightEnabled && (
                        <Button className="btn-r1gray" onClick={props.onColumnRight} disabled={!props.rightEnabled}>
                            <CursorRight />
                        </Button>
                    )}
                </th>
            </tr>
        );
    } else {
        return <tr />;
    }
};
